import { theme } from '@mtsdengi/ui-kit'

/**
 * Получение стилей для Flex контейнера
 */
export const getContainerStyles = ({ columnSpace = 0, rowSpace = 0 }) => `
    display: flex;
    flex-wrap: wrap;
    width: auto;
    margin-left: -${columnSpace * theme.spacings.sm}px;
    margin-top: -${rowSpace * theme.spacings.sm}px;
    box-sizing: border-box;
`

/**
 * Получение стилей для Flex колонки
 */
export const getColumnStyles = ({ size = 0, columns = 1, rowSpace = 0, columnSpace = 0 }) => `
    padding: ${rowSpace * theme.spacings.sm}px 0 0 ${columnSpace * theme.spacings.sm}px;
    flex-basis: ${(size / columns) * 100}%;
    box-sizing: border-box;
`
